import * as React from 'react';
import EmailFooterV2 from '../components/FooterV2';

interface WelcomeEmailProps {
  name?: string;
  company?: string;
  email?: string;
  supportEmail?: string;
  planName?: string;
  domain?: string;
}

export const WelcomeEmail: React.FC<WelcomeEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  email = 'joao.silva@email.com',
  supportEmail = 'atendimento@trivium.com.br',
  planName = 'Plano Profissional',
  domain = 'trivium.com.br',
}) => {
  return (
    <div style={containerStyle}>
      <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={tableStyle}>
        <tr>
          <td align="center">
            <table width="600" border="0" cellSpacing="0" cellPadding="0" style={innerTableStyle}>
              {/* Header */}
              <tr>
                <td align="center" style={headerStyle}>
                  <img 
                    src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B" 
                    alt="Trivium" 
                    width="120" 
                    style={logoStyle} 
                  />
                </td>
              </tr>
              {/* Body */}
              <tr>
                <td style={bodyStyle}>
                  <p style={successBadgeStyle}>🎉 Conta criada com sucesso!</p>
                  <h1 style={titleStyle}>Bem-vindo(a), <br></br>{name}! 👋</h1>
                  <p style={messageStyle}>
                    Sua conta foi criada na plataforma {company}.<br />
                    Acesse a plataforma com as suas credenciais do Microsoft 365.
                  </p>
                    <a href="https://csm.trivium.com.br" style={buttonStyle}>Acessar minha conta</a>
                </td>
              </tr>
              {/* Footer */}
              <tr>
                <td align="center">
                  <EmailFooterV2 variant="clean" showContactInfo={true} />
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  );
};

// Estilos
const containerStyle = {
  margin: '0',
  padding: '0',
  fontFamily: 'Arial, sans-serif',
  backgroundColor: '#f7f7f7',
};

const tableStyle = {
  backgroundColor: '#f7f7f7',
  padding: '40px 0',
};

const innerTableStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  overflow: 'hidden',
};

const headerStyle = {
  backgroundColor: '#1F1746',
  padding: '20px',
};

const logoStyle = {
  display: 'block',
};

const bodyStyle = {
  padding: '40px 30px',
  textAlign: 'center',
  color: '#333333',
};

const successBadgeStyle = {
  backgroundColor: '#d1fae5',
  color: '#065f46',
  display: 'inline-block',
  padding: '8px 16px',
  borderRadius: '6px',
  fontSize: '14px',
  margin: '0 0 20px',
};

const titleStyle = {
  fontSize: '24px',
  margin: '0 0 10px',
  color: '#111111',
};

const messageStyle = {
  fontSize: '16px',
  margin: '0 0 30px',
  color: '#555555',
};

const buttonStyle = {
  backgroundColor: '#1F1746',
  color: '#ffffff',
  textDecoration: 'none',
  padding: '14px 28px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 'bold',
  display: 'inline-block',
};

export default WelcomeEmail; 